import { render, staticRenderFns } from "./OrderFabricRawFabricTypeTable.vue?vue&type=template&id=72e62266&"
import script from "./OrderFabricRawFabricTypeTable.vue?vue&type=script&lang=js&"
export * from "./OrderFabricRawFabricTypeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports